<template>
  <div class="laycontainer page_wrapper">
    <asidebar :sidebarInfo="menuInfo"></asidebar>
    <mainbar></mainbar>
  </div>
</template>

<script>
import Asidebar from "./Asidebar.vue";
import Mainbar from "./Mainbar.vue";
import menuJson from "@/mock/index.js";
export default {
  components: {
    Asidebar,
    Mainbar,
  },
  data() {
    return {
      menuInfo: null,
    };
  },
  watch: {
    $route: "init",
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const matched = this.$route.matched || [];
      if (matched && matched.length > 0) {
        const { name } = matched[2];
        this.menuInfo = menuJson[name];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.laycontainer {
  display: flex;
}
</style>
